// Helper for special projects counters
// options - an object contains:
// checkMixes, checkPages, checkTags, exceptionPages, exceptionTags
// fields which are arrays
function specialProjectsCounterHelper(options) {
  if (window.kudago) {
    const city = window.kudago.location;
    if (options.cities && !options.cities.includes(city)) {
      return;
    }

    if (window.kudago.itemPageNames && window.kudago.keyword) {
      const currentKeywords = window.kudago.keyword.split(';');
      const currentPath = window.location.pathname + window.location.search;

      const isBelong = () => {
        const checkedPagesException = options.exceptionPages.some((el) => currentPath.includes(el));
        // eslint-disable-next-line max-len
        const checkedTagsException = options.exceptionTags.some((el) => currentKeywords.includes(el));

        if (checkedPagesException || checkedTagsException) {
          return false;
        }

        const checkedPages = options.checkPages.some((el) => currentPath.includes(el));
        if (checkedPages) {
          return true;
        }

        const checkedMixesAndTags = options.checkMixes.concat(options.checkTags)
          .some((el) => currentKeywords.includes(el));
        if (checkedMixesAndTags) {
          return true;
        }

        return false;
      };
      if (isBelong()) {
        window.ga('kudago.send', {
          hitType: 'event',
          eventCategory: `${options.categoryName}-${city}`,
          eventAction: 'view',
          eventLabel: currentPath,
        });
      }
    }
  }
}

module.exports = specialProjectsCounterHelper;
